// Header.js
import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  FormControl,
  Select,
  MenuItem,
  Switch,
  FormControlLabel,
} from '@mui/material';

/**
 * Header component with title, account toggle, and language selector.
 *
 * @param {Object} props
 * @param {boolean} props.fragments Indicates if fragments mode is enabled.
 * @param {function} props.setFragments Callback to toggle fragments mode.
 * @param {string} props.language Selected language.
 * @param {function} props.setLanguage Callback to change the language.
 * @return {JSX.Element} The rendered header.
 */
function Header({ fragments, setFragments, language, setLanguage }) {
  return (
    <AppBar position="static" sx={{ backgroundColor: '#333' }}>
      <Toolbar>
        {/* Left Section: Title */}
        <Box sx={{ flex: 1, textAlign: 'left' }}>
          <Typography variant="h6">
            <Box component="span" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Dofus
            </Box>
            <Box component="span" sx={{ color: '#79a223', fontWeight: 'bold' }}>
              Drop
            </Box>
          </Typography>
        </Box>
        {/* Center Section: Mono/Multi Toggle */}
        <Box sx={{ flex: 1, textAlign: 'center' }}>
          <FormControlLabel
            control={
              <Switch
                checked={fragments}
                onChange={(e) => setFragments(e.target.checked)}
                color="default"
              />
            }
            label={fragments ? 'Fragments' : 'Classic'}
            labelPlacement="start"
          />
        </Box>
        {/* Right Section: Language Selector with Flags */}
        <Box sx={{ flex: 1, textAlign: 'right' }}>
          <FormControl variant="standard" sx={{ minWidth: 140 }}>
            <Select
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              sx={{
                color: '#fff',
                '& .MuiSvgIcon-root': { color: '#fff' },
              }}
            >
              <MenuItem value="en">
                <Box component="span" sx={{ mr: 1 }} role="img" aria-label="English">
                  🇬🇧
                </Box>
                English
              </MenuItem>
              <MenuItem value="fr">
                <Box component="span" sx={{ mr: 1 }} role="img" aria-label="Français">
                  🇫🇷
                </Box>
                Français
              </MenuItem>
              <MenuItem value="es">
                <Box component="span" sx={{ mr: 1 }} role="img" aria-label="Español">
                  🇪🇸
                </Box>
                Español
              </MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
